import CloseIcon from '../../../assets/icons/close.svg?react';
import { useDeleteCblModule } from '../../../hooks/queries/cblmoduleQueries';
import { useState } from 'react';
const CblModuleDeleteModal = ({onClose, target, onSuccess}) => {
  const deleteCblModule = useDeleteCblModule();
  const [isPending, setIsPending] = useState(false);
  const handleDelete = async () => {
    try {
      setIsPending(true);
      await deleteCblModule.mutateAsync(target.CblModuleInfoSysId);
      onSuccess();
    } catch (error) {
      console.error('CBL 모듈 삭제 실패:', error);
    } finally {
      setIsPending(false);
    }
  };
  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-header">
          <h3>CBL 모듈 삭제</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content">
          <table className='gray-table mt-10'>
            <tr>
              <th>모듈명</th>
              <td>{target.ModuleName}</td>
            </tr>
            <tr>
              <th>버전</th>
              <td>{target.Version}</td>
            </tr>
            <tr>
              <th>BaseUrl</th>
              <td>{target.BaseUrl}</td>
            </tr>
          </table>
        </div>
        <div className="modal-footer">
          <button className="btn py-5 px-10 btn-style-5" onClick={onClose}>취소</button>
          <button className="btn py-5 px-10 btn-primary" onClick={handleDelete} disabled={isPending}>{isPending ? '삭제중...' : '삭제'}</button>
        </div>
        {deleteCblModule.error && (
          <div className="mt-10 text-red-500 text-c2-400">
            CBL 모듈 삭제에 실패했습니다.
          </div>
        )}
      </div>
    </div>
  )
}

export default CblModuleDeleteModal